import React from 'react';
interface LogoMarkProps {
  className?: string;
  tone?: 'light' | 'dark';
}
export function LogoMark({
  className = 'h-9 w-9',
  tone = 'dark'
}: LogoMarkProps) {
  const ink = tone === 'light' ? '#F8F5F0' : '#301D32';
  return <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false" data-id="element-48" data-mp="2j47e4atzlsj6">
      <polygon points="14,52 29,12 36,12 21,52" fill={ink} data-id="element-49" data-mp="2e5xhrwwj0lvz" />
      <polygon points="33,12 37,12 52,52 45,52" fill={ink} fillOpacity="0.55" data-id="element-50" data-mp="3bs36x4gfr0ao" />
      <rect x="20" y="36" width="30" height="4.5" fill="#A65F46" data-id="element-51" data-mp="3bq0jms6o3l9n" />
    </svg>;
}